export { default } from "./EditableTable";
